// @ts-nocheck
import styled from 'styled-components';
import fontSizeStyles from './FontSize/FontSize.style';
import spacingStyles from './Spacing/Spacing.style';
import sizingStyles from './Sizing/Sizing.style';
import colorStyles from './Color/Color.style';
import displayStyles from './Display/Display.style';
import flexBoxStyles from './FlexBox/FlexBox.style';
const baseStyleProps = ['color', 'bgColor', 'display', 'fontSize', 'width', 'height'];
const spacingStylesProps = [
    'p',
    'px',
    'py',
    'pl',
    'pr',
    'pt',
    'pb',
    'm',
    'mx',
    'my',
    'ml',
    'mr',
    'mt',
    'mb',
];
const flexBoxStylesProps = [
    'flexDirection',
    'flexWrap',
    'justifyContent',
    'alignItems',
    'alignContent',
    'order',
    'flexGrow',
    'flexShrink',
    'alignSelf',
];
const withStyles = (Component, componentStyles = '', options = {}) => {
    const { attrs, flexbox = false, spacing = false } = options;
    let stylesProps = baseStyleProps;
    /* istanbul ignore else */
    if (flexbox) {
        stylesProps = stylesProps.concat(flexBoxStylesProps);
    }
    /* istanbul ignore else */
    if (spacing) {
        stylesProps = stylesProps.concat(spacingStylesProps);
    }
    // Filter-out hoc props from child component
    const StyledComponent = styled(Component)
        .withConfig({ shouldForwardProp: (prop) => !stylesProps.includes(prop) })
        .attrs(attrs || null) `
    ${componentStyles}
    ${fontSizeStyles}
    ${spacing && spacingStyles}
    ${colorStyles}
    ${sizingStyles}
    ${displayStyles}
    ${flexbox && flexBoxStyles}
  `;
    // $FlowFixMe eslint-disable-line
    StyledComponent.defaultProps = Component.defaultProps;
    /* istanbul ignore next */
    StyledComponent.displayName = Component.displayName || Component.name || 'Component';
    /* istanbul ignore next */
    // eslint-disable-next-line no-param-reassign
    Component.displayName = `Base(${Component.displayName || Component.name || 'Component'})`;
    return StyledComponent;
};
export const withSpacingStyles = (Component) => {
    return styled(Component).withConfig({
        shouldForwardProp: (prop) => !spacingStylesProps.includes(prop),
    }) `
    ${spacingStyles}
  `;
};
export const withFlexBoxStyles = (Component) => {
    return styled(Component).withConfig({
        shouldForwardProp: (prop) => !flexBoxStylesProps.includes(prop),
    }) `
    ${flexBoxStyles}
  `;
};
export default withStyles;
